import React, { memo } from 'react';

import { Icon } from '@shipstation/svgs';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import style from './loading-indicator.less';

const LoadingIndicator = ({ className = '', theme = 'grey', 'data-testid': testId, iconClassName, iconTitle = 'spinner' }) => {
  return (
    <div className={classnames(className, style['loading-indicator'], style[theme])} data-testid={testId}>
      <div className={style['icon-wrapper']}>
        <Icon className={classnames(style.icon, iconClassName)} name='spinner' title={iconTitle} version='v2' />
      </div>
    </div>
  );
};

LoadingIndicator.propTypes = {
  theme: PropTypes.oneOf(['white', 'grey']),
  className: PropTypes.string,
  'data-testid': PropTypes.string,
  iconClassName: PropTypes.string,
  iconTitle: PropTypes.string,
};

export default memo(LoadingIndicator);
